import React, { useState, useEffect } from 'react';
import { Award } from 'lucide-react';

// Import client logos
import tm from "../../assets/images/tata_motorspng.png";
import ek from "../../assets/images/Escorts_Kubota_Limited.png";
import cm from "../../assets/images/caparo_maruti.png";
import sh from "../../assets/images/shayadari_hospital.png";
import mh from "../../assets/images/Max-Healthcare.png";
import gh from "../../assets/images/jaipur_golden.png";
import mc from "../../assets/images/minda_corp.png";
import da from "../../assets/images/dabar_automotive.png";
import amass from "../../assets/images/Amass_New_Logo 2025.png";
import jktyre from "../../assets/images/jk-tyre.webp";
import continental from "../../assets/images/Continental_Hospital_Logo.jpg";
import fortis from "../../assets/images/fortis.png";
import jtekt from "../../assets/images/④JTEKT_logo_Positive_type,_Black_+_Red.jpg";
import tatamtrs from "../../assets/images/Tata-Motors.png";

export default function OurClientsSection() {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Client data
  const clients = [
    { name: 'Tata Motors', logo: tatamtrs },
    { name: 'Escorts Kubota', logo: ek },
    { name: 'Caparo Maruti', logo: cm },
    { name: 'Sahyadri Hospital', logo: sh },
    { name: 'Max Healthcare', logo: mh },
    { name: 'Jaipur Golden Hospital', logo: gh },
    { name: 'Continental Hospital', logo: continental },
    { name: 'JK Tyre', logo: jktyre },
    { name: 'JTEKT', logo: jtekt },
    { name: 'Fortis Hospital', logo: fortis },
  ];

  // Logo dimensions
  const logoWidth = isDesktop ? 200 : 160;
  const logoHeight = isDesktop ? 100 : 80;
  const gap = isDesktop ? 50 : 30;

  // Calculate total width of one set
  const singleSetWidth = clients.length * (logoWidth + gap);

  return (
    <section style={{
      width: '100%',
      padding: isDesktop ? '80px 0' : '60px 0',
      background: '#ffffff',
      overflow: 'hidden',
    }}>
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto',
        padding: '0 24px',
      }}>
        {/* Header */}
        <div style={{
          textAlign: 'center',
          marginBottom: isDesktop ? '60px' : '40px',
        }}>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            color: '#0b3161',
            fontWeight: 600,
            fontSize: '0.85rem',
            textTransform: 'uppercase',
            letterSpacing: '1.2px',
            marginBottom: '12px',
          }}>
            <Award size={18} />
            Trusted By
          </div>
          <h2 style={{
            fontFamily: "'Roboto Slab', serif",
            color: '#081426',
            fontSize: isDesktop ? '2.5rem' : '2rem',
            margin: '0 0 12px 0',
            lineHeight: 1.2,
            fontWeight: 700,
          }}>Our Clients</h2>
          <p style={{
            color: '#64748b',
            fontSize: '1rem',
            margin: '0 auto',
            lineHeight: 1.6,
            maxWidth: '600px',
          }}>
            Partnering with leading organizations to deliver industry-focused training and skill development.
          </p>
        </div>

        {/* Infinite Scrolling Logos */}
        <div style={{
          width: '100%',
          overflow: 'hidden',
          position: 'relative',
          padding: '20px 0',
        }}>
          <div className="clients-scroll-track" style={{
            display: 'flex',
            width: 'fit-content',
          }}>
            {/* First set of logos */}
            <div className="clients-set" style={{
              display: 'flex',
              gap: `${gap}px`,
              paddingRight: `${gap}px`,
            }}>
              {clients.map((client, index) => (
                <div
                  key={`set1-${index}`}
                  style={{
                    flex: '0 0 auto',
                    width: `${logoWidth}px`,
                    height: `${logoHeight}px`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <img
                    src={client.logo}
                    alt={`${client.name} logo`}
                    style={{
                      maxWidth: '100%',
                      maxHeight: '100%',
                      objectFit: 'contain',
                    }}
                    onError={(e) => {
                      e.target.src = `https://via.placeholder.com/160x80/0b3161/ffffff?text=${client.name}`;
                    }}
                  />
                </div>
              ))}
            </div>
            {/* Second set of logos (duplicate for seamless loop) */}
            <div className="clients-set" style={{
              display: 'flex',
              gap: `${gap}px`,
              paddingRight: `${gap}px`,
            }}>
              {clients.map((client, index) => (
                <div
                  key={`set2-${index}`}
                  style={{
                    flex: '0 0 auto',
                    width: `${logoWidth}px`,
                    height: `${logoHeight}px`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <img
                    src={client.logo}
                    alt={`${client.name} logo`}
                    style={{
                      maxWidth: '100%',
                      maxHeight: '100%',
                      objectFit: 'contain',
                    }}
                    onError={(e) => {
                      e.target.src = `https://via.placeholder.com/160x80/0b3161/ffffff?text=${client.name}`;
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* CSS Animation */}
      <style>{`
        .clients-scroll-track {
          animation: clientsScroll 30s linear infinite;
        }

        @keyframes clientsScroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-${singleSetWidth}px);
          }
        }

        @media (prefers-reduced-motion: reduce) {
          .clients-scroll-track {
            animation: none;
          }
        }
      `}</style>
    </section>
  );
}